import React, { useEffect } from "react";

import { swipeBehavior, viewport } from "@telegram-apps/sdk-react";

import { PageLoader } from "@arc/ui/loader";

export const TMALayer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  useEffect(() => {
    swipeBehavior.mount();
    if (swipeBehavior.isVerticalEnabled()) {
      swipeBehavior.disableVertical();
    }
  }, [swipeBehavior]);

  useEffect(() => {
    if (!viewport) return;

    viewport.expand();
  }, [viewport]);

  if (!viewport) return <PageLoader />;

  return children;
};
